// LIFECYCLE-01 step 6 · the lifecycle read endpoints (read only; acting comes with steps 5/7).
//   GET /bp/lifecycle/<object_type>/<object_id>/  one object's lifecycle (services/lifecycle/read.py)
//   GET /bp/lifecycle/inbox/                      My actions (services/lifecycle/inbox.py)
// The plant is the session's, never a parameter.
import Axios from 'axios';

const authHeaders = () => {
  let token = '';
  try {
    token = localStorage.getItem('Token') || '';
  } catch (e) {
    token = '';
  }
  return { headers: { Authorization: `Bearer ${token}` } };
};

export const get_lifecycle_view = (objectType, objectId) =>
  Axios.get(`/bp/lifecycle/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/`, authHeaders());

/** params: { object_type?, overdue?: bool, counts_only?: bool } */
export const get_lifecycle_inbox = ({ object_type, overdue, counts_only } = {}) =>
  Axios.get('/bp/lifecycle/inbox/', {
    ...authHeaders(),
    params: {
      ...(object_type ? { object_type } : {}),
      ...(overdue ? { overdue: 1 } : {}),
      ...(counts_only ? { counts_only: 1 } : {}),
    },
  });

/** The object's own page: batch → the batch workflow; MBMR/MBPR → the record view; MFR → the MFR register opened on it. */
export const lifecycleObjectPath = (row) => {
  const id = row?.object_id;
  switch (row?.object_type) {
    case 'BATCH': {
      const bn = row.batch_number || row.code;
      return `/batch-workflow?batch_number=${encodeURIComponent(bn || '')}`;
    }
    case 'MBMR':
    case 'MBPR':
      return `/recipe-view/${encodeURIComponent(id)}/view`;
    case 'MFR':
      return `/mfr?id=${encodeURIComponent(id)}`;
    default:
      return null;
  }
};
